export default (arr) => (Array.isArray(arr) && arr.length > 0)
